import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { emailSchema, passwordSchema } from "../utils/validationSchemas";
import { useNavigate } from "react-router-dom";
import AuthService from "../services/LoginService";
import StorageService from "../services/StorageService";

export default function AuthLoginForm() {
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const user = StorageService.loginData();
    if (user) {
      if (user.roleId === 1) {
        navigate("/company-selection");
      } else {
        navigate("/cpnl/dashboard");
      }
    }
  }, []);

  useEffect(() => {
    if (!errorMessage) return;

    const timer = setTimeout(() => {
      setErrorMessage("");
    }, 3000);

    return () => clearTimeout(timer);
  }, [errorMessage]);


  const { register, handleSubmit, formState: { errors } } = useForm({
    mode: "onChange",
  });

  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = async (data) => {
    setErrorMessage("");
    setSuccessMessage("");
    setLoading(true);

    try {
      const res = await AuthService.login(data);

      if (res.status) {
        StorageService.setLoginData(res.user);
        setSuccessMessage("Login Successful!");

        setTimeout(() => {
          if (res.user.roleId == 1) {
            navigate("/company-selection");
          } else {
            StorageService.setActiveCompany({
              id: res.user.companyId,
              companyName: res.user.companyName
            });
            navigate("/cpnl/dashboard");
          }
        }, 1200);
      } else {
        const msg = res.message || "Invalid email or password";
        setErrorMessage(msg);

        // setTimeout(() => {
        //   setErrorMessage("");
        // }, 3000);

      }

    } catch (err) {
      setErrorMessage(err.message);
      // setTimeout(() => {
      //   setErrorMessage("");
      // }, 3000);
    }

    setLoading(false);
  };

  return (
    <div className="auth-main">
      <div className="auth-wrapper v1">
        <div className="auth-form">
          <div className="position-relative">
            <div className="auth-bg">
              <span className="r"></span>
              <span className="r s"></span>
              <span className="r s"></span>
              <span className="r"></span>
            </div>

            <div className="mb-0 card container">
              <div className="card-body">

                <div className="text-center">
                  <img src="../assets/images/deviops_logo.png" style={{ height: "120px" }} />
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                  <h4 className="text-center f-w-500 mt-4 mb-3">DeviOps Login</h4>

                  <div className="mb-3">
                    <input
                      placeholder="Email ID or Login ID"
                      type="text"
                      {...register("loginIdOrEmail", { required: "Login ID or Email is required" })}
                      className={`form-control ${errors.loginIdOrEmail ? "is-invalid" : ""}`}
                    />
                    <div className="invalid-feedback">{errors.loginIdOrEmail?.message}</div>
                  </div>

                  <div className="mb-3">
                    <div className="input-group">
                      <input
                        placeholder="Password"
                        type={showPassword ? "text" : "password"}
                        {...register("password", passwordSchema)}
                        className={`form-control ${errors.password ? "is-invalid" : ""}`}
                      />

                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <i className={showPassword ? "ti ti-eye" : "ti ti-eye-off"}></i>
                      </button>
                    </div>
                    <div className="invalid-feedback">{errors.password?.message}</div>
                  </div>

                  {loading && (
                    <div className="text-center my-3">
                      <div className="simple-loader"></div>
                    </div>
                  )}

                  {errorMessage && (
                    <div className="alert alert-danger mt-3">{errorMessage}</div>
                  )}

                  {successMessage && (
                    <div className="alert alert-success mt-3">{successMessage}</div>
                  )}

                  <div className="text-center mt-4">
                    <button
                      type="submit"
                      className="shadow px-sm-4 btn btn-primary"
                    >
                      Login
                    </button>
                  </div>

                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
